"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Web Storage implementation based on an in-memory Map.
 * @see https://html.spec.whatwg.org/multipage/webstorage.html#the-storage-interface
 */

var InMemoryStorage = function () {
    function InMemoryStorage() {
        (0, _classCallCheck3.default)(this, InMemoryStorage);

        this.storage = new Map([]);
    }

    (0, _createClass3.default)(InMemoryStorage, [{
        key: "length",
        value: function length() {
            return this.storage.size;
        }
    }, {
        key: "getItem",
        value: function getItem(key) {
            return this.storage.get(key);
        }
    }, {
        key: "setItem",
        value: function setItem(key, value) {
            this.storage.set(key, value);
        }
    }, {
        key: "removeItem",
        value: function removeItem(key) {
            this.storage.delete(key);
        }
    }, {
        key: "clear",
        value: function clear() {
            this.storage.clear();
        }
    }]);
    return InMemoryStorage;
}();

exports.default = InMemoryStorage;
